import { Link } from '@tanstack/react-router';
import { Card, CardContent, ContextMenu, IconButton, SystemIcon, Typography } from '@volvo/vcdk-react';
import React from 'react';

import { withComponentErrorBoundary } from '@/components/ComponentErrorBoundary';
import FleetUnitCount from '@/components/FleetUnitCount';
import DeleteFleetModal from '@/components/modals/DeleteFleetModal';
import EditFleetModal from '@/components/modals/EditFleetModal';
import { fleet } from '@/utils';

type Props = {
  id: string;
  avatar?: string;
  name: string;
  entityVersion: number;
};

export const FLEET_PINNED_KEY = 'vpc_pinned_fleet_ids';

const FleetCard: React.FC<Props> = ({ id, name, entityVersion }) => {
  const fleetDetails = fleet.parseFleetName(name);

  return (
    <Card>
      <Link
        to="/fleets/$fleetId/dashboard"
        params={{ fleetId: id }}
        className="hover:bg-neutral-light flex flex-1 flex-col"
      >
        <CardContent>
          <div className="flex flex-col gap-4">
            <div className="bg-gray-light flex size-11 items-center justify-center rounded">
              <SystemIcon icon={fleetDetails.icon} size={32} />
            </div>
            <Typography variant="heading4">{fleetDetails.fleetName}</Typography>
            <FleetUnitCount fleetId={id} unit="units" variant="body" className="text-subtle" />
          </div>
        </CardContent>
      </Link>
      <div className="absolute top-8 right-8">
        <ContextMenu trigger="click" placement="bottom-end">
          <span slot="trigger">
            <IconButton icon="kebab-menu" />
          </span>
          {/* {isPinned ? (
            <ContextMenuItem onClick={handleOnUnpin}>
              {t(($) => $.pages.account.fleet_overview.unpin)}
            </ContextMenuItem>
          ) : (
            <ContextMenuItem onClick={handleOnPin}>
              {t(($) => $.pages.account.fleet_overview.pin)}
            </ContextMenuItem>
          )} */}
          <EditFleetModal fleetId={id} entityVersion={entityVersion} name={name} />
          <DeleteFleetModal fleetId={id} entityVersion={entityVersion} />
        </ContextMenu>
      </div>
    </Card>
  );
};

export default withComponentErrorBoundary(FleetCard);
